import GameClan from '../entities/gameClan';

const gameClanDataTransformationAfterFetch = (data) => {
    return data.map((row) => {
        return new GameClan(row);
    });
};

export default gameClanDataTransformationAfterFetch;
